import React from 'react'

const GeneralRequirements = (props) => {
  return (
    <div className="tab">
      <h2>System Requirements</h2>
      <ul>
        <li>A Microsoft Windows or Apple Computer, Apple iPad or Google Android Tablet.</li>
        <li>Integrated/external speakers or headphones.</li>
        <li>2 Mbps or faster internet connection. To test your internet speed, <a target="_blank" rel="noopener noreferrer" href="http://lmscourses.speedtestcustom.com/">click here</a>.</li>
      </ul>
    </div>
  )
}

export default GeneralRequirements
